import React from "react";
import Autocomplete from "./Autocomplete";
import { useUser } from "../hooks/query";

interface User {
    Id: string;
    FirstName: string;
    LastName: string;
    Email: string;
}

interface UserSelectorProps {
    name: string;
    label: string;
    placeholder?: string;
    rules?: any;
    helperText?: string;
    size?: "sm" | "md" | "lg";
    helperType?: "tooltip" | undefined;
    disabled?: boolean;
}

const UserSelector: React.FC<UserSelectorProps> = ({
    name,
    label,
    placeholder = "Select user",
    rules = {},
    helperText,
    size = "md",
    helperType,
    disabled = false,
    ...props
}) => {
    const { useList } = useUser();
    const { data, isLoading } = useList();

    const users = (Array.isArray(data) ? data : []) as User[];

    const userOptions = users.map((user) => ({
        value: user.Id,
        label: `${user.FirstName} ${user.LastName}`,
        user: user,
    }));

    return (
        <Autocomplete
            name={name}
            label={label}
            placeholder={placeholder}
            rules={rules}
            helperText={helperText}
            size={size}
            helperType={helperType}
            options={userOptions}
            disabled={disabled || isLoading}
            {...props}
        />
    );
};

export default UserSelector;
